import React from 'react';
import ComboTotalPage from './components/ComboTotalPage';

function ComboTotal() {
  return <ComboTotalPage />;
}

export default ComboTotal;
